"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MetaHierarchy = void 0;
/**
 * Restricts values of the user-action event metaHierarchy items on the apps/checkout-client-app component level.
 */
let MetaHierarchy = exports.MetaHierarchy = /*#__PURE__*/function (MetaHierarchy) {
  /** Main checkout steps navigation (1st level). The snake_case ID is required for GA integration. */
  MetaHierarchy["CheckoutNavigation"] = "checkout_navigation_select";
  /** Navigation to the shopping bag step. */
  MetaHierarchy["Basket"] = "shopping bag";
  /** Navigation to the offers step. */
  MetaHierarchy["Offers"] = "offers";
  /** Navigation to the review step. */
  MetaHierarchy["Review"] = "review";
  /**
   * User clicked the Change / Order preview button in the Review (Checkout) step.
   * Thus returning back to Basket (Shopping bag) step.
   */
  MetaHierarchy["SelectOrderPreview"] = "checkout_order_preview_select";
  return MetaHierarchy;
}({});